import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Menu, X, ChevronDown } from 'lucide-react';
import { Button } from './ui/button';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isAboutOpen, setIsAboutOpen] = useState(false);
  const navigate = useNavigate();

  const menuItems = [
    { label: 'Home', path: '/' },
    { label: 'Products', path: '/products' },
    { label: 'Blog', path: '/blog' },
    { label: 'Contact', path: '/contact' }
  ];

  const aboutDropdown = [
    { label: 'About Us', path: '/about' },
    { label: 'Services', path: '/services' },
    { label: 'How We Work', path: '/how-we-work' },
    { label: 'Why GoldenPort', path: '/why-goldenport' }
  ];

  return (
    <header className="bg-white shadow-md sticky top-0 z-50">
      <div className="container mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <Link to="/" className="flex items-center">
            <img 
              src="https://customer-assets.emergentagent.com/job_bec05211-66fe-40f4-be9b-9c2beecb0c73/artifacts/bvs625is_Logogo.png" 
              alt="GoldenPort International" 
              className="h-16 w-auto"
            />
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center gap-6">
            {menuItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className="text-[#0B2C4D] hover:text-[#C9A24D] font-medium transition-colors duration-200"
              >
                {item.label}
              </Link>
            ))}
            
            {/* About Dropdown */}
            <div 
              className="relative"
              onMouseEnter={() => setIsAboutOpen(true)}
              onMouseLeave={() => setIsAboutOpen(false)}
            >
              <button className="flex items-center gap-1 text-[#0B2C4D] hover:text-[#C9A24D] font-medium transition-colors duration-200">
                About
                <ChevronDown className={`w-4 h-4 transition-transform duration-200 ${isAboutOpen ? 'rotate-180' : ''}`} />
              </button>
              
              {isAboutOpen && (
                <div className="absolute top-full left-0 mt-2 w-56 bg-white rounded-lg shadow-xl border border-gray-100 py-2 z-50">
                  {aboutDropdown.map((item) => (
                    <Link
                      key={item.path}
                      to={item.path}
                      className="block px-4 py-3 text-[#0B2C4D] hover:bg-[#C9A24D] hover:text-white transition-colors duration-200"
                      onClick={() => setIsAboutOpen(false)}
                    >
                      {item.label}
                    </Link>
                  ))}
                </div>
              )}
            </div>
            
            <Button
              className="bg-[#0B2C4D] hover:bg-[#0a2542] text-white border border-[#C9A24D]"
              onClick={() => window.open('/admin-login', '_blank')}
            >
              Login
            </Button>
          </nav>

          {/* Mobile Menu Button */}
          <button
            className="lg:hidden text-[#0B2C4D]"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            {isMenuOpen ? <X size={28} /> : <Menu size={28} />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <nav className="lg:hidden mt-4 pb-4 border-t border-gray-200 pt-4">
            {menuItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className="block py-2 text-[#0B2C4D] hover:text-[#C9A24D] font-medium transition-colors duration-200"
                onClick={() => setIsMenuOpen(false)}
              >
                {item.label}
              </Link>
            ))}
            
            {/* About Section in Mobile */}
            <div className="py-2">
              <button 
                className="flex items-center justify-between w-full text-[#0B2C4D] font-medium"
                onClick={() => setIsAboutOpen(!isAboutOpen)}
              >
                About
                <ChevronDown className={`w-4 h-4 transition-transform duration-200 ${isAboutOpen ? 'rotate-180' : ''}`} />
              </button>
              
              {isAboutOpen && (
                <div className="ml-4 mt-2 space-y-2">
                  {aboutDropdown.map((item) => (
                    <Link
                      key={item.path}
                      to={item.path}
                      className="block py-2 text-[#0B2C4D] hover:text-[#C9A24D] transition-colors duration-200"
                      onClick={() => {
                        setIsMenuOpen(false);
                        setIsAboutOpen(false);
                      }}
                    >
                      {item.label}
                    </Link>
                  ))}
                </div>
              )}
            </div>
            
            <Button
              className="w-full mt-4 bg-[#0B2C4D] hover:bg-[#0a2542] text-white border border-[#C9A24D]"
              onClick={() => {
                window.open('/admin-login', '_blank');
                setIsMenuOpen(false);
              }}
            >
              Login
            </Button>
          </nav>
        )}
      </div>
    </header>
  );
};

export default Header;
